import PropTypes from 'prop-types';
import { memo, useState, Fragment, useCallback } from 'react';

import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
import ListSubheader from '@mui/material/ListSubheader';

import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionVertical({ data, slotProps, ...other }) {
  return (
    <>
      {data.map((group, index) => (
        <Stack component="nav" id="nav-section-vertical" {...other}>
          <Group
            key={group.subheader || index}
            subheader={group.subheader}
            items={group.items}
            slotProps={slotProps}
          />
        </Stack>
      ))}
    </>

  );
}

NavSectionVertical.propTypes = {
  data: PropTypes.array,
  slotProps: PropTypes.object,
};

export default memo(NavSectionVertical);

// ----------------------------------------------------------------------

function Group({ subheader, items, slotProps }) {
  const [open, setOpen] = useState(true);

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const renderContent = items.map((list, key) => (
    <Box key={list.title || key} sx={{ position: "relative", mb: 1 }}>
      <Stack
        sx={{
          backgroundImage: `url(${list?.logo})`,
          height: "120px",
          borderRadius: '4px',
          backgroundSize: 'contain',
          backgroundPosition: 'right',
          bgcolor: 'background.neutral',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <Box sx={{
        position: "absolute", top: '50%',
        left: "5px",
        transform: "translateY(-50%)",
        height: "100%",

      }}
      >
        <NavList data={list} depth={1} slotProps={slotProps} />
      </Box>
    </Box>
  ));

  return (
    <Stack sx={{ px: 2 }}>
      {subheader ? (
        <>
          <ListSubheader
            disableGutters
            disableSticky
            onClick={handleToggle}
            sx={{
              fontSize: 11,
              cursor: 'pointer',
              typography: 'overline',
              display: 'inline-flex',
              color: 'text.disabled',
              mb: `${slotProps?.gap || 4}px`,
              p: (theme) => theme.spacing(2, 1, 1, 1.5),
              transition: (theme) =>
                theme.transitions.create(['color'], {
                  duration: theme.transitions.duration.shortest,
                }),
              '&:hover': {
                color: 'text.primary',
              },
              ...slotProps?.subheader,
            }}
          >
            {subheader}
          </ListSubheader>

          <Collapse in={open}>{renderContent}</Collapse>
        </>
      ) : (
        renderContent
      )}
    </Stack>
  );
}

Group.propTypes = {
  items: PropTypes.array,
  subheader: PropTypes.string,
  slotProps: PropTypes.object,
};
